export default "__VITE_ASSET__D1E791Id__"